import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 1015.98 1015.98"
    {...props}
  >
    <path
      fillRule="nonzero"
      d="M495.6 12.38c0-6.84 5.55-12.39 12.39-12.39 6.84 0 12.39 5.55 12.39 12.39v961.31l474.46-474.46c4.83-4.83 12.69-4.83 17.52 0s4.83 12.69 0 17.52l-495.61 495.61c-2.55 2.43-5.16 3.51-8.76 3.63-3.59-.12-6.22-1.21-8.76-3.63L3.62 516.75c-4.83-4.83-4.83-12.69 0-17.52s12.69-4.83 17.52 0L495.6 973.69V12.38z"
      className="fil0 str0"
    />
  </svg>
);
export default SvgArrowDown;
